import ConsumerFeedbackModal, { CONSUMER_FEEDBACK_MODAL } from './modal';

export { CONSUMER_FEEDBACK_MODAL };

export default ConsumerFeedbackModal;
